import BallotIcon from "@mui/icons-material/Ballot";
import { Box, Button } from "@mui/material";
import { BaseModalComponent } from "../common/BaseModalComponent";
import { WidgetComponentCharts } from "../common/WidgetComponentCharts";
import SectorWorkflowConfiguration from "./SectorWorkflowConfiguration";
import { widgetSmallHeight } from "../../utils";

export const SOWWidget = () => {
  return (
    <WidgetComponentCharts
      sxProp={{ height: widgetSmallHeight }}
      swapyName="sow-widget"
      title="Services & SOW"
      icon={<BallotIcon />}
      description="Configure and manage the sector workflow entities."
      data={
        <Box sx={{ display: "flex", flex: 1, alignItems: "center", justifyContent: "center", height: "100%" }}>
          <BaseModalComponent
            defaultSizes={{ width: "100%" }}
            modalKey="Admin-config-services"
            modalLabel="Configure Sector Workflow"
            elementTrigger={
              <Button
                variant="outlined"
                sx={{
                  textTransform: "none",
                  fontWeight: 700,
                  borderRadius: "8px",
                  borderColor: "rgba(var(--fx-surface-textrgb, 15, 23, 42), 0.12)",
                  color: "var(--fx-surface-textsecondary, #64748B)",
                  "&:hover": {
                    borderColor: "rgba(var(--fx-surface-textrgb, 15, 23, 42), 0.24)",
                  },
                }}
              >
                Configure Sector Workflow
              </Button>
            }
          >
            <SectorWorkflowConfiguration />
          </BaseModalComponent>
        </Box>
      }
    />
  );
};
